import {
    room,
    micMutedIcon,
    hideSideMenu,
    CONV_STORAGE,
    Video,
    socket,
    onStage,
    muteAll,
    kinoControls,
    permissions
} from "../libs/roomnew";

export default class MuteParticipants {
    constructor() {
        this.muteIcon = `<div class="kinetx-icon">
        <svg width="48px" height="48px" viewBox="0 0 48 48">
            <g id="mic-muted">
                <path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="none" stroke="none"></path>
                <path d="M18 20C18 23.3 15.3 26 12 26L6 26C2.7 26 0 23.3 0 20L0 6C0 2.7 2.7 0 6 0L12 0C15.3 0 18 2.7 18 6L18 20L18 20Z" transform="translate(15 4)" id="Shape" fill="#032836" stroke="none"></path>
                <path d="M0 0L4 0L4 10L0 10L0 0Z" transform="translate(22 34)" id="Shape" fill="#78909c" stroke="none"></path>
                <path d="M22 2C22 2 16 0 11 0C6 0 0 2 0 2L0 4L22 4L22 2L22 2Z" transform="translate(13 41)" id="Shape" fill="#032836" stroke="none"></path>
                <path d="M0 0L8 0L8 2L0 2L0 0ZM18 0L10 0L10 2L18 2L18 0ZM8 4L0 4L0 6L8 6L8 4ZM10 4L18 4L18 6L10 6L10 4ZM8 8L0 8L0 10L8 10L8 8ZM10 8L18 8L18 10L10 10L10 8ZM0 12L8 12L8 14L0 14L0 12ZM18 12L10 12L10 14L18 14L18 12Z" transform="translate(15 10)" id="Shape" fill="#78909c" fill-rule="evenodd" stroke="none"></path>
                <path d="M13 17L9 17C5.9 17 0 15.3 0 9L0 0L2 0L2 9C2 14.9 8.7 15 9 15L13 15C13.3 15 20 14.9 20 9L20 0L22 0L22 9C22 15.3 16.1 17 13 17L13 17Z" transform="translate(13 18)" id="Shape" fill="#032836" stroke="none"></path>
                <path d="M0 0L4 0L4 53.7L0 53.7L0 0Z" transform="matrix(0.7070944 -0.7071192 0.7071192 0.7070944 3.564331 6.393372)" id="Shape" fill="#78909c" stroke="none"></path>
            </g>
        </svg>
    </div>`;
        this.muteWhiteIcon=`<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M33 24C33 27.3 30.3 30 27 30H21C17.7 30 15 27.3 15 24V10C15 6.7 17.7 4 21 4H27C30.3 4 33 6.7 33 10V24Z" fill="#CFD8DC"/>
        <path d="M22 34H26V44H22V34Z" fill="#78909C"/>
        <path d="M35 43C35 43 29 41 24 41C19 41 13 43 13 43V45H35V43Z" fill="#CFD8DC"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15 10H23V12H15V10ZM33 10H25V12H33V10ZM23 14H15V16H23V14ZM25 14H33V16H25V14ZM23 18H15V20H23V18ZM25 18H33V20H25V18ZM15 22H23V24H15V22ZM33 22H25V24H33V22Z" fill="#78909C"/>
        <path d="M26 35H22C18.9 35 13 33.3 13 27V18H15V27C15 32.9 21.7 33 22 33H26C26.3 33 33 32.9 33 27V18H35V27C35 33.3 29.1 35 26 35Z" fill="#CFD8DC"/>
        <path d="M3.56433 6.39337L6.39271 3.56489L44.365 41.5359L41.5366 44.3643L3.56433 6.39337Z" fill="#78909C"/>
        </svg>
        `;
        this.btn = null;
        this.btnLabel = "Mute All";
        this.optionsBtn=null;

    };

    events(){
        let m=this;
        socket.events.MuteAll=this.muteEvent.bind(m);
    }

    addOptionButton() {
        var m = this;
        m.enabled = true;
        if (!m.isModerator()) {
            // console.error('show_mute_all_button_no access')
            return
        }
        // console.error('adding mute_all button')

        kinoControls.registerControl('mute-all',m.muteIcon,'Mute everyone',"button","Mute",(el)=>{
            m.muteAll();
        });
        muteAll.addControlButton();
    };

    removeOptionButton() {
        var m = this;
        m.enabled = false;
        muteAll.setMuteAllState(false);
        // if (m.optionsBtn !== null) {
        //     m.optionsBtn.remove();
        // }
        // m.optionsBtn = null;
        // $("#option-list").find("#kinoMuteParticipantsBtn").remove();
    };

    isModerator() {
        return permissions.hasMuteAll();
    }

    canIMuteParticipant(pid){
        if (!this.isModerator() || Video.announcement.announcers.includes(pid)) {
            return false;
        }
        let p_cid=CONV_STORAGE.isOnConversation(pid);
        if(p_cid==CONV_STORAGE.myConversation){return true};
        if(!p_cid && !CONV_STORAGE.myConversation){return true};
        return false;
    };

    renderMuteButtons(){
        // console.error("render_mute_buttons");
        if (!this.isModerator()) {
            return
        }
        // console.error("render_mute_buttons loop");
        Object.keys(Video.videos).map(async (pid)=>{
            if(this.canIMuteParticipant(pid)){
                Video.videos[pid].showMuteButton();
            }else{
                Video.videos[pid].hideMuteButton();
            }
        });
    };

    hideMuteButtons(){
        Object.keys(Video.videos).map(async (pid)=>{
                Video.videos[pid].hideMuteButton();
        });
    }

    muteAll() {
        if (!this.isModerator()) {
            return
        }
        try {
            socket.emit({
                eventName:"MuteAll",
                mute_mic: "all",
                from_id:room.myUserId(),
                space_id: CONV_STORAGE.myConversation ? CONV_STORAGE.myConversation : 'lobby'
            });
            //leave support for mobile
            // room.broadcastEndpointMessage({
            //     mute_mic: "all",
            //     space_id: CONV_STORAGE.myConversation ? CONV_STORAGE.myConversation : 'lobby'
            // });
        } catch (error) {
            console.log("unable to mute participants", error);
        }
    };
    muteParticipant(pid) {
        if (!this.isModerator()) {
            return
        }
        try {
            socket.emit({
                eventName:"MuteAll",
                mute_mic: "participant",
                pid:pid,
                from_id:room.myUserId(),
                space_id: CONV_STORAGE.myConversation ? CONV_STORAGE.myConversation : 'lobby'
            });
            //leave support for mobile
            // room.sendEndpointMessage(pid, {
            //     mute_mic: "participant",
            //     space_id: CONV_STORAGE.myConversation ? CONV_STORAGE.myConversation : 'lobby'
            // });
        } catch (error) {
            console.log("unable to mute participants", error);
        }
    };

    muteEvent(message) {
        if( (message.space_id == CONV_STORAGE.myConversation || (!CONV_STORAGE.myConversation && message.space_id=="lobby")) && !Video.announcement.announcing){
                if((!onStage.myStage.isStageView() && !this.isModerator()) || message.mute_mic=="participant"){
                    this.setMicMuted(message.from_id);
                }
        }
    };

    setMicMuted(from_id) {
        try {
            if (!room.getLocalAudioTrack()) {return}
            if (!room.getLocalAudioTrack().isMuted()) {
                Video.showNotification('',`Microphones have been muted by the moderators`,'mute_all',from_id);
                room.getLocalAudioTrack().mute();
                // $("#room-mute-mic").attr('data-original-title', 'Mic Off');
                // $("#room-mute-mic").attr('title', 'Mic Off');
                $("#room-mute-mic").html(micMutedIcon);
            }
        } catch (e) {
            console.log("Can not mute audio",e);
        }
    }

};
